<script setup>

// 定义 props
const props = defineProps({
    footer: {
        type: Object,
        required: true,
        default: () => Object.create(null)
    }
})

// 响应式引用
const videoEl = ref(null)
let observer = null

// 计算属性
const isVideo = computed(() => {
    const img = props.footer.card_img
    return img && /\.(mp4|webm|ogg)$/i.test(img)
})

const videoType = computed(() => {
    const ext = (props.footer.card_img || '').split('.').pop().toLowerCase()
    return `video/${ext === 'webm' ? 'webm' : ext === 'ogg' ? 'ogg' : 'mp4'}`
})

const alignmentClass = computed(() => {
    const alignIndex = (props.footer.card_align || 3) - 1
    const alignments = ['left', 'right', 'center']
    return `align-${alignments[alignIndex]}`
})

// 方法
const initVideoObserver = () => {
    if (!isVideo.value || !videoEl.value) return

    observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    videoEl.value.play().catch(e => console.warn('视频自动播放失败:', e))
                } else {
                    videoEl.value.pause()
                }
            })
        },
        {
            threshold: 0.5
        }
    )

    observer.observe(videoEl.value)
}

const cleanupVideoObserver = () => {
    if (observer) {
        observer.disconnect()
        observer = null
    }
}

// 生命周期钩子
onMounted(() => {
    if (isVideo.value) {
        initVideoObserver()
    }
})

onBeforeUnmount(() => {
    if (isVideo.value) {
        cleanupVideoObserver()
    }
})
</script>
<template>
    <div class="Heziyun-bottomCard">
        <div class="Heziyun-defaultWidth">
            <template v-if="isVideo">
                <video ref="videoEl" preload="none" loop muted playsinline disablepictureinpicture>
                    <source :src="footer.card_img" :type="videoType" />
                </video>
            </template>
            <template v-else>
                <img :src="footer.card_img" alt="加入我们" loading="lazy" />
            </template>
            <div class="hero" :class="alignmentClass">
                <h1>{{ footer.card_title }}</h1>
                <a :href="footer.card_btnurl" v-show="footer.card_btnurl">{{ footer.card_btnname }}</a>
            </div>
        </div>
    </div>
</template>

<style lang="less" scoped>
// 底部卡片
.Heziyun-bottomCard {
    position: relative;

    #webgl-canvas {
        height: 12rem !important;
        max-height: 12rem;
        object-fit: cover;
        position: initial !important;
        width: 100% !important;
    }

    video {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .hero {
        position: relative;
        z-index: 1;
        height: 12rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 2rem;
        // background: url('../../assets/img/index/footerca.png') no-repeat center;
        background-size: cover;

        h1 {
            font-size: 1.7rem;
            font-weight: 700;
            text-shadow: 0 0 20px rgba(0, 0, 0, 1);
            line-height: 100%;
            color: white;
            text-transform: uppercase;
            user-select: none;
            letter-spacing: 0.4rem;
        }

        a {
            color: #fff;
            background: #3176FF;
            padding: 0.6rem 2rem;
            border-radius: 0.2rem;
            -webkit-border-radius: 0.2rem;
            -moz-border-radius: 0.2rem;
            -ms-border-radius: 0.2rem;
            -o-border-radius: 0.2rem;

            &:hover {
                background: #699bff;
            }
        }

        button {
            font-family: "Montserrat", serif;
            background: rgba(255, 255, 255, 0.5);
            border-radius: 5px;
            border: 1px solid grey;
            padding: 4px 8px;
        }
    }

    .align-left {
        align-items: flex-start;
    }

    .align-center {
        align-items: center;
    }

    .align-right {
        align-items: flex-end;
    }

}

// 底部卡片
@media (max-width: 768px) {
    .Heziyun-bottomCard {
        position: relative;

        #webgl-canvas {
            height: 25vw !important;
            max-height: 25vw;
        }

        .hero {
            gap: 3vw;
            height: 25vw;

            h1 {
                font-size: 4vw;
                letter-spacing: 0.5vw;
            }

            a {
                color: #fff;
                background: #3176FF;
                padding: 2vw 5vw;
                font-size: 3.5vw;
                border-radius: 1vw;
                -webkit-border-radius: 1vw;
                -moz-border-radius: 1vw;
                -ms-border-radius: 1vw;
                -o-border-radius: 1vw;
            }
        }

    }
}
</style>